import type { HTMLAttributes, ReactNode } from 'react';

export type BkPanelProps = {
  children: ReactNode;
  className?: string;
  padded?: boolean;
  raised?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export default function BkPanel({
  children,
  className = '',
  padded = true,
  raised = false,
  ...rest
}: BkPanelProps) {
  return (
    <div
      className={[
        'border border-bk-gold-dim/50 bg-bk-panel text-bk-text shadow-[inset_0_1px_0_color-mix(in_srgb,var(--color-bk-gold)_15%,transparent),0_8px_24px_rgba(0,0,0,0.45)]',
        raised ? 'bg-bk-panel-raised' : '',
        padded ? 'p-4 sm:p-6' : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}
